import { Directive, HostListener, inject } from '@angular/core';

import { NavigationService } from '@bookly-shared/core';

@Directive({
  selector: '[bshNavigateBack]',
})
export class NavigateBackDirective {
  readonly #navigationService = inject(NavigationService);

  @HostListener('click')
  public onClick(): void {
    this.#navigationService.back();
  }
}
